import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-25722a84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "lottie-container-weekloading",
  class: "loading-wrapper"
}, null, -1))
const _hoisted_3 = { class: "progress-wrapper" }
const _hoisted_4 = { class: "progress-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_progress = _resolveComponent("van-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_progress, {
        "stroke-width": 8,
        percentage: $props.progress,
        "show-pivot": false,
        class: "progress"
      }, null, 8, ["percentage"]),
      _createElementVNode("span", _hoisted_4, _toDisplayString($props.progress) + "%", 1)
    ])
  ]))
}